import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Breadcrumbs, FormWrapper, SubmitButton } from "../../components";
import { useProject } from "../../hooks";
import { parseAmount } from "../../services/utils";

function ProjectPlotPage() {
  const { plotNumber, phaseId, projectId } = useParams();
  const { getPlotDetails, updatePlot } = useProject();

  const [plotData, setPlotData] = useState({});
  const [formData, setFormData] = useState({
    plot_area: "",
    total_plot_amount: "",
    max_negotiation_limit: "",
  });

  const fetchPlotData = async () => {
    const { plot, error } = await getPlotDetails(projectId, phaseId, plotNumber);
    if (error) {
      toast.error(error);
      return;
    }
    const newPlotData = {
      ...plot,
      emi: plot.emi ? `${plot.emi.replace(/.00|,/g, "")} ${plot.emi < 2 ? "month" : "months"}` : null,
      plot_area: `${plot.plot_area}`.replace(".00", ""),
    };
    setPlotData(newPlotData);
    Object.keys(formData).forEach((key) => {
      setFormData((prev) => ({ ...prev, [key]: newPlotData[key] }));
    });
  };
  useEffect(() => {
    fetchPlotData();
  }, []);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { success, error } = await updatePlot(plotData.id, formData);
    if (error) return toast.error(error);
    toast.success(success);
    navigate(`/project-listing?id=${projectId}&from=plot`);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    const totalPlotAmount = newValue * plotData.plot_rate;
    const maxNegotiateAmount = newValue * plotData.max_negotiate_rate;
    setFormData({
      ...formData,
      plot_area: newValue,
      total_plot_amount: totalPlotAmount,
      max_negotiation_limit: maxNegotiateAmount,
    });
  };

  const breadcrumbs = [
    { name: "Project Listing", link: `/project-listing/?id=${projectId}` },
    { name: `Plot #${plotNumber}` },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <section className="section_wrapper">
        <div className="section_title_wrapper">
          <h2 className="section_title">Plot #{plotNumber}</h2>
        </div>
        <FormWrapper id="plot_form" onSubmit={handleSubmit}>
          <section className="section grid_3">
            <div className="column">
              <div className="row">
                <span className="label">Total plot amount</span>
                <span className="value">{parseAmount(formData.total_plot_amount)}</span>
              </div>
              <div className="row">
                <span className="label">Area</span>
                <div className="input_with_suffix_wrapper">
                  <input
                    type="number"
                    className="input"
                    value={formData.plot_area}
                    onChange={handleInputChange}
                    min={plotData.plot_area_min}
                    max={plotData.plot_area_max}
                    required
                  />
                  <span className="suffix">sq.ft</span>
                </div>
              </div>
              <div className="row">
                <span className="label">Rate per sq.ft.</span>
                <span className="value">{parseAmount(plotData.plot_rate)}/sq.ft</span>
              </div>
              <div className="row">
                <span className="label">EMI Rate Limit (per sq.ft.)</span>
                <span className="value">{parseAmount(plotData.max_negotiate_rate)}/sq.ft</span>
              </div>
              <div className="row">
                <span className="label">EMI</span>
                <span className="value">{plotData.emi}</span>
              </div>
              <div className="row">
                <span className="label">Down Payment Rate limit</span>
                <span className="value">{parseAmount(plotData.rate_limit)}/sq.ft</span>
              </div>
              <div className="row">
                <span className="label">Phase</span>
                <span className="value">Phase {phaseId}</span>
              </div>
            </div>
            <div className="vertical_divider"></div>
            <div className="column">
              <div className="row">
                <span className="label">Token percent</span>
                <span className="value">{`${plotData.token_percent}`.replace(".00", "")}%</span>
              </div>
              <div className="row">
                <span className="label">Token percent (minimum limit)</span>
                <span className="value">{`${plotData.token_percent_limit}`.replace(".00", "")}%</span>
              </div>
              <div className="row">
                <span className="label">
                  Registration charges <br /> + Advocate fees + Satbara
                </span>
                <span className="value">{parseAmount(plotData.registration_charges)}</span>
              </div>
              <div className="row">
                <span className="label">Development Charges (Water & Electricity)</span>
                <span className="value">{parseAmount(plotData.development_charges)}</span>
              </div>
              <div className="row">
                <span className="label">Commission payable to agent</span>
                <span className="value">{`${plotData.agent_commission}`.replace(".00", "")}%</span>
              </div>
              <div className="row">
                <span className="label">Company commission</span>
                <span className="value">{`${plotData.company_commission}`.replace(".00", "")}%</span>
              </div>
              <div className="row">
                <span className="label">Put on hold</span>
                <span className="value">{plotData.days_to_put_on_hold} days</span>
              </div>
              <div className="row">
                <span className="label">Rate/Day to hold the plot</span>
                <span className="value">{parseAmount(plotData.rate_per_day_to_hold_plot)}</span>
              </div>
            </div>
          </section>
          <SubmitButton className="submit" form="plot_form" end>
            SUBMIT
          </SubmitButton>
        </FormWrapper>
      </section>
    </>
  );
}

export default ProjectPlotPage;
